import React, { useState, useEffect, useRef, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import useForm from 'react-hook-form';
import Loader from '../common/loader';
import { toast } from 'react-toastify';
import api from '../../config/axios';
import utils from '../../utils/miscUtils';
import { useStateValue } from '../../store';
import { generateClientEmail, extractCoords, detectShortMapsUrl, normalizePhoneVE } from './parse-whatsapp';

const { makePasswordRandom } = utils;

const NewClient = withRouter(({ history }) => {
    const { handleSubmit, register, errors, getValues } = useForm();
    const [state, setState] = useState({
        loading: false,
        stepLoading: 1,
        resolved: false,
        data: null,
        error: null,
    });
    const [loaded, setLoaded] = useState(false);
    const [settings, setSettings] = useState(null);
    const [{ auth }] = useStateValue();
    const { franchiseId } = auth.user;
    const [map, setMap] = useState(null);
    const [bottleImage, setBottleImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    // URL de Google Maps pegada por el encargado (opcional, mueve el pin)
    const [mapsUrlInput, setMapsUrlInput] = useState('');
    const mapsUrlTimer = useRef(null);
    // Loading mientras se expande el link corto de Maps (~3s de red)
    const [mapsLoading, setMapsLoading] = useState(false);
    // Chequeo anti-duplicado vía /client/exist
    const [existCheck, setExistCheck] = useState({ status: 'idle' });
    // Nombre para el preview del correo automático (read-only)
    const [nameForEmail, setNameForEmail] = useState('');

    // Fetchs info when component is mounted
    useEffect(() => {
        //register({ name: 'location' }, { required: true });
        Promise.all([fetchSettings(franchiseId)]).then((values) => {
            setSettings(values[0]);
            setLoaded(true);

            // Ask for geolocation permit
            navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
                if (result.state === 'granted') {
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition((position, error, options) => {
                            if (position) {
                                initGoogleMap(position.coords.latitude, position.coords.longitude);
                            } else {
                                initGoogleMap(
                                    values[0][0].referencePoint.coordinates[1],
                                    values[0][0].referencePoint.coordinates[0],
                                );
                            }
                        });
                    } else {
                        initGoogleMap(
                            values[0][0].referencePoint.coordinates[1],
                            values[0][0].referencePoint.coordinates[0],
                        );
                    }
                } else if (result.state === 'prompt') {
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition((position, error, options) => {
                            if (position) {
                                initGoogleMap(position.coords.latitude, position.coords.longitude);
                            } else {
                                initGoogleMap(
                                    values[0][0].referencePoint.coordinates[1],
                                    values[0][0].referencePoint.coordinates[0],
                                );
                            }
                        });
                    } else {
                        initGoogleMap(
                            values[0][0].referencePoint.coordinates[1],
                            values[0][0].referencePoint.coordinates[0],
                        );
                    }
                } else {
                    initGoogleMap(
                        values[0][0].referencePoint.coordinates[1],
                        values[0][0].referencePoint.coordinates[0],
                    );
                }
            });
        });
    }, []);

    const initGoogleMap = (lat, lng) => {
        let map = new window.google.maps.Map(document.getElementById(`map`), {
            center: {
                lat: lat,
                lng: lng,
            },
            zoom: 17,
            mapTypeControl: false,
            streetViewControl: false,
        });
        const marker = new window.google.maps.Marker({
            position: {
                lat: lat,
                lng: lng,
            },
            map,
        });

        map.addListener('center_changed', () => {
            var newLatLng = new window.google.maps.LatLng(map.center.lat(), map.center.lng());

            marker.setPosition(newLatLng);
        });
        setMap(map);
    };

    const fetchSettings = async () => {
        // consulta los settings dependiendo del usuario logueado
        // si está logueado un usuario FRANQUICIA trae sólo los settings de ese usuario
        // si está logueado un usuario ADMIN trae todos los settings de la DB

        let url = !!franchiseId ? `/franchise/${franchiseId}/settings` : '/settings';
        const { data } = await api.get(url);
        const settings = data.data;

        return settings;
    };

    const compressAndUpload = async (file, clientId, street1) => {
        // Comprimir
        const compressedBlob = await compressImage(file);

        // Convertir Blob a Buffer/ArrayBuffer para S3
        const arrayBuffer = await compressedBlob.arrayBuffer();
        const buffer = Buffer.from(arrayBuffer);

        // Subir a S3
        const imageUrl = await handleImageS3(file, buffer, clientId, street1);
        return imageUrl;
    };

    const compressImage = async (file) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                // Redimensionar manteniendo proporción
                const maxWidth = 700;
                const ratio = maxWidth / img.width;
                canvas.width = maxWidth;
                canvas.height = img.height * ratio;

                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                // Comprimir a JPEG
                canvas.toBlob(
                    (blob) => {
                        resolve(blob);
                    },
                    'image/jpg',
                    0.8,
                );
            };
        });
    };

    /**
     * Handle request of signed URL and upload procces of files to AWS S3
     * @param {Object} data Information about category (name, image, src)
     * @return {String} URL to store in DB
     */
    const handleImageS3 = async (file, buffer, idCliente, nameAddress) => {
        const addressTrimmed = nameAddress.split(' ')[0];
        const fileName = `${idCliente}-${addressTrimmed}.${file.type.split('/')[1]}`;
        const fileType = file.type;
        const requestSigning = {
            fileName,
            fileType,
        };

        // request signedurl to AWS
        const responseAWS = await api.post('/aws/request-url-signed', requestSigning);
        const { signedRequest, url } = responseAWS.data.data;

        // upload image directly to S3 bucket
        try {
            await axios({
                url: signedRequest,
                method: 'PUT',
                data: buffer,
                headers: {
                    'Content-Type': fileType,
                },
            });
            return url;
        } catch (e) {
            console.log(e);
        }
    };

    const handleNewClient = async (data) => {
        // Correo automático: nombreapellido@aguamandelivery.com.
        // Menos fricción al cliente: no se le pide el correo al registrar.
        // (Si algún día se necesita el correo real, se actualiza en el detalle del cliente.)
        let email = generateClientEmail(data.name);
        try {
            // Guard anti-colisión: si otro cliente ya tiene ese correo
            // (mismo nombre completo), se agregan los últimos 4 dígitos
            // del teléfono → pedrofernandez3538@aguamandelivery.com
            const response = await api.get('/client/exist', {
                params: { email, phone_number: data.phone_number },
            });
            if (response.data && response.data.data && response.data.data.email === true) {
                const suffix = (data.phone_number || '').replace(/\D/g, '').slice(-4);
                email = generateClientEmail(data.name, suffix);
            }
        } catch (e) {
            // Si el chequeo falla se usa el correo base: el signup avisará si está repetido
        }

        const dataClient = {
            ...data,
            email,
            // Normaliza "+58 412-1231127" / "0414-…" / "412…" → 584121231127
            // (el replace('0','58') anterior se rompía con +58 y Number() daba NaN)
            phone_number: Number(
                normalizePhoneVE(data.phone_number) || data.phone_number.replace(/\D/g, ''),
            ),
            auth_type: 'local',
            password: makePasswordRandom(),
            requestSource: 'admin',
            createdByUserId: auth.user.id,
        };
        setState({
            ...state,
            loading: true,
        });
        api.post('/client/signup', dataClient)
            .then(async (response) => {
                setState({
                    ...state,
                    stepLoading: 2,
                });

                const clientId = response.data.data.client.id;

                // upload image to s3
                let imageUrl = null;

                if (bottleImage) {
                    imageUrl = await compressAndUpload(bottleImage, clientId, data.street1);

                    imageUrl = imageUrl.replace(
                        'https://aguaman-envases-clientes.s3.amazonaws.com/',
                        'https://dxot6n0pcppgt.cloudfront.net/',
                    );
                }

                const dataAddress = {
                    street1: data.street1,
                    street2: data.street2,
                    house_number: 'N/A',
                    latitude: map?.center.lat(),
                    longitude: map?.center.lng(),
                    observation: data.observation,
                    photoBottle: imageUrl,
                    longway: data.longway ? true : false,
                    newBottles: data.newBottles || 0,
                };

                api.post(`/client/${clientId}/address`, dataAddress)
                    .then(() => {
                        toast.success('Cliente agregado con éxito');
                        history.push(`/clientes/${clientId}`);
                        setState({
                            ...state,
                            loading: false,
                            resolved: true,
                        });
                    })
                    .catch((error) => {
                        toast.error('Hubo un error al agregar la dirección. Intente de nuevo');
                        setState({
                            ...state,
                            loading: false,
                            error: error,
                        });
                    });
            })
            .catch((error) => {
                if (error.response && error.response.status === 409) {
                    toast.error(error.response.data.errors[0].msg);
                    setState({
                        ...state,
                        loading: false,
                    });
                    return;
                }
                toast.error('Hubo un error al agregar el cliente. Intente de nuevo');
                setState({
                    ...state,
                    loading: false,
                });
            });
    };

    const handleBottleImageChange = (e) => {
        const file = e.target.files[0];
        setBottleImage(file);
        setImagePreview(URL.createObjectURL(file));
    };

    /** Centra el mapa en unas coordenadas y sube el zoom. */
    const centerMap = (coords) => {
        if (!map || coords.lat === null) return;
        map.setCenter({ lat: coords.lat, lng: coords.lng });
        map.setZoom(17);
    };

    /**
     * Detecta la ubicación desde lo pegado en el campo URL de Google Maps:
     * - URL larga de Maps → coordenadas directas (@lat,lng / !3d!4d / ?q=)
     * - URL corta (goo.gl) → se expande vía /misc/expand-url y se parsea
     * - Coordenadas sueltas "7.7665, -72.2287" → directas
     * Mueve el pin del mapa (el guardado usa la posición del pin).
     */
    const applyMapsInput = async (value) => {
        const trimmed = (value || '').trim();
        if (!trimmed) return;

        // Coordenadas sueltas
        const direct = extractCoords(trimmed);
        if (direct.lat !== null) {
            centerMap(direct);
            toast.success('📍 Ubicación detectada');
            return;
        }

        // URL larga: las coordenadas vienen en el propio texto
        const fromLong = extractCoords(decodeURIComponent(safeUrl(trimmed)));
        if (fromLong.lat !== null) {
            centerMap(fromLong);
            toast.success('📍 Ubicación detectada');
            return;
        }

        // URL corta: expandir vía API
        const short = detectShortMapsUrl(trimmed);
        if (short) {
            setMapsLoading(true);
            try {
                const response = await api.get('/misc/expand-url', {
                    // _t evita que el navegador devuelva un 304 sin cuerpo
                    // (cacheado de una expansión anterior del mismo link)
                    params: { url: short, _t: Date.now() },
                });
                const expandedUrl = response.data && response.data.data && response.data.data.url;
                if (expandedUrl) {
                    const coords = extractCoords(decodeURIComponent(expandedUrl));
                    if (coords.lat !== null) {
                        centerMap(coords);
                        toast.success('📍 Ubicación detectada');
                        return;
                    }
                }
                toast.warn('El link no trae coordenadas — mueve el pin manualmente');
            } catch (e) {
                toast.warn('No pude resolver el link de Maps — mueve el pin o pega las coordenadas');
            } finally {
                setMapsLoading(false);
            }
        }
    };

    // decodeURIComponent falla si el texto tiene un % suelto — no rompe el flujo
    const safeUrl = (text) => {
        try {
            return decodeURIComponent(text);
        } catch (e) {
            return text;
        }
    };

    const handleMapsUrlChange = (e) => {
        const value = e.target.value;
        setMapsUrlInput(value);
        clearTimeout(mapsUrlTimer.current);
        // Debounce: al pegar el link, el pin se mueve ~1s después
        mapsUrlTimer.current = setTimeout(() => applyMapsInput(value), 1000);
    };

    /**
     * Consulta /client/exist con el teléfono normalizado y el correo
     * generado del nombre. Muestra alerta inline si el cliente ya existe.
     * Nota: requiere teléfono — el endpoint falla (500) si phone_number
     * llega undefined; en la práctica el teléfono siempre se llena (required).
     */
    const checkExistingClient = async (phoneRaw, name) => {
        const phone = normalizePhoneVE(phoneRaw);
        const email = generateClientEmail(name);
        if (!phone) {
            setExistCheck({ status: 'idle' });
            return;
        }
        setExistCheck({ status: 'checking' });
        try {
            const response = await api.get('/client/exist', {
                params: { email, phone_number: phone },
            });
            const data = (response.data && response.data.data) || {};
            setExistCheck({
                status: data.email || data.phoneNumber ? 'exists' : 'ok',
                phoneExists: data.phoneNumber === true,
                emailExists: data.email === true,
                name: data.name || null,
            });
        } catch (e) {
            // si el chequeo falla no bloqueamos el registro
            setExistCheck({ status: 'idle' });
        }
    };

    const handlePhoneBlur = (e) => {
        checkExistingClient(e.target.value, nameForEmail);
    };

    const handleNameBlur = (e) => {
        const name = e.target.value;
        setNameForEmail(name);
        const phone = getValues('phone_number');
        if (phone) checkExistingClient(phone, name);
    };

    if (!loaded)
        return (
            <div style={{ display: 'flex', height: '50vh' }}>
                <Loader />
            </div>
        );

    return (
        <Fragment>
            {state.loading && (
                <div
                    style={{
                        display: 'flex',
                        height: '50vh',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Loader />
                    <h3>Cargando</h3>
                    {state.stepLoading === 1 && <p>Guardando Cliente</p>}
                    {state.stepLoading === 2 && <p>Guardando Dirección</p>}
                </div>
            )}
            <div className="container-fluid form-client"
                style={{ display: state.loading ? 'none' : 'block' }}
            >
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row product-adding">
                                    <div className="col-xl-10 offset-xl-1">
                                        <div className="needs-validation add-product-form mt-0">
                                            <div className="form form-label-center">
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="name"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-user" /> Nombre Completo
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="name"
                                                            placeholder="Pedro Perez"
                                                            ref={register({
                                                                required: true,
                                                            })}
                                                            onBlur={handleNameBlur}
                                                        />
                                                        {errors.name &&
                                                            errors.name.type === 'required' && (
                                                                <p className="message-error-input">
                                                                    Nombre es obligatorio
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="name"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-phone" /> Teléfono
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="04147353821"
                                                            name="phone_number"
                                                            inputMode="numeric"
                                                            ref={register({
                                                                required: true,
                                                            })}
                                                            onBlur={handlePhoneBlur}
                                                        />
                                                        {errors.phone_number &&
                                                            errors.phone_number.type ===
                                                                'required' && (
                                                                <p className="message-error-input">
                                                                    Teléfono es obligatorio
                                                                </p>
                                                            )}
                                                        {existCheck.status === 'checking' && (
                                                            <small className="form-text text-muted">
                                                                Verificando si el cliente ya
                                                                existe…
                                                            </small>
                                                        )}
                                                        {existCheck.status === 'exists' && (
                                                            <p className="message-error-input">
                                                                ⚠️ Ya existe un cliente{' '}
                                                                {existCheck.phoneExists
                                                                    ? 'con este teléfono'
                                                                    : 'con este nombre (mismo correo generado)'}
                                                                {existCheck.name
                                                                    ? `: ${existCheck.name}`
                                                                    : ''}
                                                                . Verifica si es el mismo antes de
                                                                guardar.
                                                            </p>
                                                        )}
                                                        {existCheck.status === 'ok' && (
                                                            <small className="form-text text-success">
                                                                ✓ Cliente nuevo (sin coincidencias)
                                                            </small>
                                                        )}
                                                    </div>
                                                </div>
                                                {/* Email: ya no se pide al cliente (bajar
                                                    fricción — muchos clientes tienen el
                                                    correo lleno de spam o ni lo leen).
                                                    Se genera automático del nombre:
                                                    nombreapellido@aguamandelivery.com.
                                                    Si se necesita el correo real, se
                                                    actualiza en el detalle del cliente. */}
                                                {/*
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="email"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-envelope" /> Email
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            placeholder="romer@ejemplo.com"
                                                            name="email"
                                                            ref={register({
                                                                required: true,
                                                                pattern:
                                                                    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/i,
                                                            })}
                                                        />
                                                        {errors.email &&
                                                            errors.email.type === 'required' && (
                                                                <p className="message-error-input">
                                                                    Email es obligatorio
                                                                </p>
                                                            )}
                                                        {errors.email &&
                                                            errors.email.type === 'pattern' && (
                                                                <p className="message-error-input">
                                                                    Email incorrecto. Debe ingresar
                                                                    un tipo de email adecuado
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                                */}
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="email"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-envelope" /> Email
                                                        (automático)
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            readOnly
                                                            tabIndex={-1}
                                                            value={
                                                                generateClientEmail(nameForEmail) ||
                                                                ''
                                                            }
                                                            placeholder="Se genera del nombre al guardar"
                                                        />
                                                        <small className="form-text text-muted">
                                                            Generado del nombre. Si ya existe un
                                                            cliente con el mismo nombre, se
                                                            agregan 4 dígitos del teléfono.
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row product-adding">
                                    <div className="col-xl-10 offset-xl-1">
                                        <div className="needs-validation add-product-form mt-0">
                                            <div className="form form-label-center">
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="street1"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-map-pin" /> Dirección de
                                                        entrega
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="street1"
                                                            className="form-control"
                                                            placeholder="Sector, avenida, calle, carrera"
                                                            name="street1"
                                                            ref={register({
                                                                required: true,
                                                            })}
                                                        />
                                                        {errors.street1 &&
                                                            errors.street1.type === 'required' && (
                                                                <p className="message-error-input">
                                                                    Dirección obligatoria
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="street2"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-building" /> Edificio,
                                                        casa
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="street2"
                                                            className="form-control"
                                                            placeholder="Número de casa, edificio, piso, apto"
                                                            name="street2"
                                                            ref={register({
                                                                required: true,
                                                            })}
                                                        />
                                                        {errors.street2 &&
                                                            errors.street2.type === 'required' && (
                                                                <p className="message-error-input">
                                                                    Este campo es obligatorio
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>

                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="email"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-map-marker" /> GPS:
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                height: 300,
                                                            }}
                                                            id="map"
                                                        />
                                                        {errors.location &&
                                                            errors.location.type === 'required' && (
                                                                <p className="message-error-input">
                                                                    Ubicación GPS es obligatoria
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-link" /> URL de Google
                                                        Maps (opcional)
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="https://maps.app.goo.gl/… o 7.7665, -72.2287"
                                                            value={mapsUrlInput}
                                                            onChange={handleMapsUrlChange}
                                                            disabled={mapsLoading}
                                                        />
                                                        {mapsLoading ? (
                                                            <small className="form-text text-muted">
                                                                <i className="fa fa-spinner fa-spin" />{' '}
                                                                Buscando ubicación…
                                                            </small>
                                                        ) : (
                                                            <small className="form-text text-muted">
                                                                Pega el link de la ubicación que
                                                                envió el cliente: el pin se mueve
                                                                solo.
                                                            </small>
                                                        )}
                                                    </div>
                                                </div>
                                                <br />
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="newBottles"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-tint" /> Botellones
                                                        nuevos
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Cantidad de botellones nuevos"
                                                            name="newBottles"
                                                            defaultValue={0}
                                                            min={0}
                                                            ref={register({
                                                                required: false,
                                                            })}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="observation"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        Observación de la dirección
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="observation"
                                                            className="form-control"
                                                            placeholder="Tipo de envase"
                                                            name="observation"
                                                            ref={register({
                                                                required: false,
                                                            })}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-road" /> Tipo de
                                                        ruta
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <div className="form-check pl-0">
                                                            <label
                                                                className="d-flex align-items-center"
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <input
                                                                    style={{
                                                                        width: 20,
                                                                        height: 20,
                                                                        marginRight: 10,
                                                                        cursor: 'pointer',
                                                                        flexShrink: 0,
                                                                    }}
                                                                    type="checkbox"
                                                                    id="longway"
                                                                    name="longway"
                                                                    value={true}
                                                                    ref={register({
                                                                        required: false,
                                                                    })}
                                                                />
                                                                Dirección larga (carrera larga)
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="photoBottle"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-camera" /> Foto del
                                                        botellón
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            name="photoBottle"
                                                            accept="image/*"
                                                            onChange={handleBottleImageChange}
                                                        />
                                                        {imagePreview && (
                                                            <div
                                                                style={{
                                                                    marginTop: 10,
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                <img
                                                                    src={imagePreview}
                                                                    alt="Preview"
                                                                    style={{
                                                                        maxWidth: 200,
                                                                        maxHeight: 200,
                                                                        borderRadius: 8,
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 text-center mt-5 mb-3">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        onClick={handleSubmit(handleNewClient)}
                                    >
                                        Guardar usuario
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
});

export default NewClient;
